import clsx from "clsx";
import { Icon, Text } from "./base";

type AgentSessionDirectionPillProps = {
  direction: "inbound" | "outbound";
};

export const AgentSessionDirectionPill = ({ direction }: AgentSessionDirectionPillProps) => {
  return (
    <Text
      className={clsx(
        "w-auto px-2 py-0.5 rounded-full text-xs flex items-center",
        direction === "inbound" && "bg-purple-100 dark:bg-purple-900/20 text-purple-800 dark:text-purple-300",
        direction === "outbound" && "bg-orange-100 dark:bg-orange-900/20 text-orange-800 dark:text-orange-300",
      )}
    >
      <Icon
        name={direction === "inbound" ? "phone-inbound" : "phone-outbound"}
        size={9}
        className={clsx("mr-1 mt-0.5", direction === "inbound" ? "fill-purple-800 dark:fill-purple-300" : "fill-orange-800 dark:fill-orange-300")}
      />
      {direction === "inbound" ? "Inbound" : "Outbound"}
    </Text>
  );
};
